import React from 'react';

import type { FieldsGroupRestrictionPayload } from '@/forms/typings';

import './GroupRestrictionErrors.scss';

export interface GroupRestrictionHintProps {
  restriction?: FieldsGroupRestrictionPayload;
}

/** States a group's rules under its heading: AtLeastOneChildWithValue marked required, AtLeastOneChildAnsweredYes in bold. */
export const GroupRestrictionHint: React.FC<GroupRestrictionHintProps> = ({
  restriction,
}) => {
  const hint = restriction?.atLeastOneChildWithValue?.hint?.trim();
  const answeredYes = restriction?.atLeastOneChildAnsweredYes?.message?.trim();

  return (
    <>
      {hint && (
        <p className="group-restriction-hint">
          {hint} <span style={{ color: 'var(--color_error)' }}>*</span>
        </p>
      )}
      {answeredYes && (
        <p className="group-restriction-hint group-restriction-hint--bold">
          {answeredYes}
        </p>
      )}
    </>
  );
};
